export default [
    {
        path: 'newsletters',
        name: 'newsletters-master-data',
        meta: {
            modules: ['newsletter'],
            authentication_required: true,
            authorization_required: ['modules.newsletter'],
            translate: (t) => {
                return t('menu_points.newsletter.newsletters').ucFirst();
            },
        },
        component: () => import('@/views/helpers/grouper/grouper.vue'),
        children: [
            {
                path: 'statuses',
                name: 'newsletters-statuses',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: ['roles.newsletter'],
                    translate: (t) => {
                        return t('menu_points.newsletter.statuses').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'newsletters-statuses-list'},
                children: [
                    {
                        path: '',
                        name: 'newsletters-statuses-list',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.newsletter.statuses').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/newsletters/statuses/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'newsletters-status-create',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::statuses.status', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/statuses/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'newsletters-status-edit',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::statuses.status', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/statuses/item.vue')
                    },
                ]
            },
            {
                path: 'priorities',
                name: 'newsletters-priorities',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.newsletter.priorities').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'newsletters-priorities-list'},
                children: [
                    {
                        path: '',
                        name: 'newsletters-priorities-list',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.newsletter.priorities').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/newsletters/priorities/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'newsletters-priority-create',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::priorities.priority', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/priorities/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'newsletters-priority-edit',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::priorities.priority', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/priorities/item.vue')
                    },
                ]
            },
            {
                path: 'signatures',
                name: 'newsletters-signatures',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.newsletter.signatures').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'newsletters-signatures-list'},
                children: [
                    {
                        path: '',
                        name: 'newsletters-signatures-list',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.newsletter.signatures').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/newsletters/signatures/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'newsletters-signature-create',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::signatures.signature', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/signatures/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'newsletters-signature-edit',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::signatures.signature', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/signatures/item.vue')
                    },
                ]
            },
            {
                path: 'templates',
                name: 'newsletters-templates',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.newsletter.templates').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'newsletters-templates-list'},
                children: [
                    {
                        path: '',
                        name: 'newsletters-templates-list',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.newsletter.templates').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/newsletters/templates/list.vue')
                    },
                    /*{
                        path: 'create',
                        name: 'newsletters-template-create',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::templates.template', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/templates/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'newsletters-template-edit',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::templates.template', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/templates/item.vue')
                    }*/
                ]
            },
            {
                path: 'periods',
                name: 'newsletters-periods',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.newsletter.periods').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'newsletters-periods-list'},
                children: [
                    {
                        path: '',
                        name: 'newsletters-periods-list',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.newsletter.periods').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/newsletters/periods/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'newsletters-period-create',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::periods.period', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/periods/item.vue')
                    },
                    {
                        path: ':id(\\d+)',
                        name: 'newsletters-period-edit',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::periods.period', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/periods/item.vue')
                    },
                ]
            },
            {
                path: 'source-authentication-types',
                name: 'newsletters-source-authentication-types',
                meta: {
                    modules: ['newsletter'],
                    authentication_required: true,
                    authorization_required: null,
                    translate: (t) => {
                        return t('menu_points.newsletter.source_auth_types').ucFirst();
                    },
                },
                component: () => import('@/views/helpers/grouper/grouper.vue'),
                redirect: { name: 'newsletters-source-authentication-types-list'},
                children: [
                    {
                        path: '',
                        name: 'newsletters-source-authentication-types-list',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t) => {
                                return t('menu_points.newsletter.source_auth_types').ucFirst();
                            },
                        },
                        component: () => import('@/views/pages/newsletters/source-auth-types/list.vue')
                    },
                    {
                        path: 'create',
                        name: 'newsletters-source-authentication-type-create',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.create_new_item', {item: tc('newsletters::source_auth_types.source_auth_type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/source-auth-types/item.vue')

                    },
                    {
                        path: ':id(\\d+)',
                        name: 'newsletters-source-authentication-type-edit',
                        meta: {
                            modules: ['newsletter'],
                            authentication_required: true,
                            authorization_required: null,
                            translate: (t, tc) => t('base.edit_item', {item: tc('newsletters::source_auth_types.source_auth_type', 1)}).ucFirst()
                        },
                        component: () => import('@/views/pages/newsletters/source-auth-types/item.vue')
                    },
                ]
            },
        ]
    }
];